// extracted by mini-css-extract-plugin
export default {"root":"style_root__isiLg","content":"style_content__VqU28","abilities":"style_abilities__bbWQ5","heading":"style_heading__9OYxz"};